import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { forkJoin } from 'rxjs';
import { WebStorage } from 'src/app/demo/components/auth/storage/web.storage';
import { MasterLookupDTO } from 'src/app/demo/model/MasterLookupDTO';
import { RoomDTO } from 'src/app/demo/model/RoomDTO';
import { StaffDTO } from 'src/app/demo/model/StaffDTO';
import { StudentDTO } from 'src/app/demo/model/StudentDTO';
import { TagDTO } from 'src/app/demo/model/TagDTO';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { OperationService } from 'src/app/demo/service/operation.service';
import { profielBackgroundColor } from 'src/app/demo/sharing/constants/profielBackgroundColor';
import { Common } from 'src/app/demo/utils/common';

@Component({
    selector: 'app-mark-absent-stud',
    templateUrl: './mark-absent-stud.component.html',
    styleUrls: ['./mark-absent-stud.component.scss']
})
export class MarkAbsentStudComponent {
    userData: any;
    search: any = {};
    pageContext = {
        page: 0,
        previousPage: 0,
        itemsPerPage: 25,
        totalItems: 0,
        sort: 'id,asc',
    };
    items!: MenuItem[];
    activeIndex: number = 0;
    fromDate !: string;
    toDate !: string;
    todayDate!: string;
    dateClickedFirstTime: boolean = false;

    roomList: RoomDTO[] = [];
    roomObj: RoomDTO = {};
    tagList: TagDTO[] = [];
    statusList: MasterLookupDTO[] = [];
    selectedRoomId: any;
    selectedTagId: any;
    selectedStatus: any;
    studentList: StudentDTO[] = [];
    selectAllStudents: boolean = false;
    selectedStudents: any[] = [];
    selectedStudentIds: number[] = [];
    selectedStudentList: any[] = [];
    actualStudList: StudentDTO[] = [];
    studentSearchInput: any;
    submitForm: boolean = false;
    fromOverView: boolean = false;
    presentStudentIds: any[] = [];
    staffObj: StaffDTO = {};
    roomIds: any[] = [];
    backgroundColors: string[] = [];

    constructor(
        private lookupService: LookupService,
        private operationService: OperationService,
        private storage: WebStorage,
        private formBuilder: FormBuilder,
        private messageService: MessageService,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public router: Router,
        private confirmationService: ConfirmationService,

    ) {
        this.backgroundColors = profielBackgroundColor;
        this.roomObj = this.config.data;
        this.activeIndex = this.config.data.activeIndex;
        this.fromOverView = this.config.data.fromOverView ? true : false;
        this.selectedStudentList = this.config.data.fromOverView ? this.config.data.selectedStudents : [];
        this.selectedStudents = this.config.data.fromOverView ? this.config.data.selectedStudents : [];
        this.presentStudentIds = this.config.data.presentStudentIds;

    }

    ngOnInit(): void {
        this.userData = this.storage.getUserData();
        this.items = [
            {
                label: 'Select Students',
                command: (event: any) =>
                    this.messageService.add({
                        severity: 'info',
                        summary: 'First Step',
                        key: 'message',
                        detail: event.item.label,
                        life: 3000,
                    }),
            },
            {
                label: 'Confirm Student',
                command: (event: any) =>
                    this.messageService.add({
                        severity: 'info',
                        key: 'message',
                        summary: 'Second Step',
                        detail: event.item.label,
                        life: 3000,
                    }),
            },
        ];
        this.fromDate = Common.momentTimeZoneDate(new Date);
        this.toDate = Common.momentTimeZoneDate(new Date);
        this.todayDate = Common.momentTimeZoneDate(new Date);
        this.lookupService.getStaffById(this.userData.refTableId).subscribe((res: HttpResponse<StaffDTO>) => {
            let temp: StaffDTO = {};
            this.staffObj = res.body ? res.body : temp;
            this.roomIds = [];
            this.selectedRoomId = !Common.isAdminUserLogin(this.storage) ? this.staffObj.primaryRoomId : undefined;

            if (this.staffObj.rooms && this.staffObj.rooms.length > 0) {
              this.roomIds = this.staffObj.rooms
                .filter((room: RoomDTO) => room?.id !== undefined && typeof room.id === 'number')
                .map((room: RoomDTO) => room.id as number);
            }

            if (this.staffObj.primaryRoomId && typeof this.staffObj.primaryRoomId === 'number') {
              this.roomIds.push(this.staffObj.primaryRoomId);
            }
            this.queryData();
            this.getRoomData();
        });

        this.filterRoom();
        this.getTagData();
        this.getMasterlookupData();
    }

    onActiveIndexChange(event: number) {
        this.activeIndex = event;
    }

    complete() {
        if (this.selectedStudentIds.length != 0) {
            this.activeIndex = 1;
        } else {
            this.activeIndex = 0;
        }
    }

    prevPage() {
        this.activeIndex = 0;
    }

    callOnce : boolean = false;
    onSave() {
        if (!this.callOnce && Array.isArray(this.selectedStudents) && this.selectedStudents.length > 0) {
            this.callOnce = true;
            const requests: any[] = []; // Store API call observables
            // const currentTime = moment.utc().format('HH:mm:ss.SSS A');
            // const currentTime24hr = moment.utc().format('HH:mm:ss.SSS');
            // const formatTo12Hour = (time: string): string => {
            //     if (!time) return ''; // Handle undefined or null cases
            //     const [hours, minutes] = time.split(':'); // Extract hours and minutes
            //     let hour = parseInt(hours, 10);
            //     const ampm = hour >= 12 ? 'PM' : 'AM';
            //     hour = hour % 12 || 12;
            //     return `${hour.toString().padStart(2, '0')}:${minutes}:00 ${ampm}`; // Add seconds as 00
            // };

            // Loop through selected students and create individual payloads
            for (const student of this.selectedStudents) {
                const payload: any = {
                    note: student.absentNote || "",
                    // startDate: Common.convertLocalDateToUTC(this.fromDate),
                    // endDate: Common.convertLocalDateToUTC(this.toDate),
                    fromDate: this.fromDate,
                    toDate: this.toDate ?? this.fromDate,
                    status: "A",
                    schoolId: this.userData.schoolId,
                    studentId: student.id,
                    lastModified: moment.utc().format(),
                    lastModifiedBy: this.userData.email + " from Mobile",
                    staffId: null,
                    roomId: student.roomId,
                    absentMarkTime: Common.convertLocalDateToUTC(Common.momentTimeZoneDate(new Date())),
                    // absentBy: this.userData.firstName
                    absentMarkedBy: this.userData.firstName,
                    hasStudentId: true,

                };

                // Push API request into the array
                requests.push(this.operationService.createAbsentMultipleDays(payload));
            }

            // Use forkJoin to execute all requests
            forkJoin(requests).subscribe({
                next: () => {
                    this.ref.close({
                        severity: 'success',
                        life: 3000,
                        summary: 'Success',
                        detail: 'Absent marked successfully.'
                    });
                    setTimeout(() => {
                        this.router.navigateByUrl('/student-Sign-In/absentStudent');
                        this.callOnce = false;
                    }, 1000);
                },
                error: (error) => {
                    this.ref.close({
                        severity: 'error',
                        life: 3000,
                        summary: 'Error',
                        detail: error?.error?.detail || 'An error occurred while submitting.'
                    });
                    this.callOnce = false; // Reset callOnce on error
                }
            });

        }
    }


    queryData() {
        this.search.sort = 'fullName,asc';
        this.search['profileStatus.equals'] = 'A';
        this.search['status.equals'] = 'A';
        this.search['schoolId.equals'] = this.userData.schoolId;
        // this.search['studentId.notIn'] = (moment(this.toDate).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD')
        // || moment(this.fromDate).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD')) ? this.presentStudentIds : undefined;
        if (this.fromDate && this.toDate) {

        this.search["date.greaterThanOrEqual"] = Common.getUtcStartOfDay(this.fromDate);
        this.search["date.lessThanOrEqual"] = Common.getUtcEndOfDay(this.toDate);
        }
        this.search['room.id.in'] = !Common.isAdminUserLogin(this.storage) ? this.roomIds : undefined;
        this.search['roomId.equals'] = this.selectedRoomId;
        Common.removeEmptyFields(this.search);
        this.lookupService.queryStudentAbsent(this.search)
            .subscribe(async (res: HttpResponse<StudentDTO[]>) => {
                let temp: StudentDTO[] = [];
                this.studentList = res.body ? res.body : temp;
                this.fetchActualStudentList();
                for (const student of this.studentList) {
                    if (student) {
                        if (student.photoUuid) {
                            this.lookupService.queryDocumentByPhotoUid(student.photoUuid).subscribe((response: HttpResponse<Blob>) => {
                                const body = response?.body;
                                if (body) {
                                    const url = this.createImgFromBuffer(body);
                                    student.profileimg = url;
                                }
                            });
                        } else {
                            student.profileimg = undefined;
                        }

                    }
                }
            });
    }

    fetchActualStudentList() {
        this.search = {};
        this.search.sort = 'fullName,asc';
        this.search['profileStatus.equals'] = 'A';
        this.search['status.equals'] = 'A';
        this.search['schoolId.equals'] = this.userData.schoolId;
        // this.search['studentId.notIn'] = (this.fromDate == Common.momentTimeZoneDate(new Date) && this.toDate == Common.momentTimeZoneDate(new Date)) ? this.presentStudentIds : undefined;
        if (this.fromDate && this.toDate) {

            this.search["date.greaterThanOrEqual"] = Common.getUtcStartOfDay(this.fromDate);
            this.search["date.lessThanOrEqual"] = Common.getUtcEndOfDay(this.toDate);
        }
        this.search['room.id.in'] = !Common.isAdminUserLogin(this.storage) ? this.roomIds : undefined;
        Common.removeEmptyFields(this.search);
        this.lookupService.queryStudentAbsent(this.search)
            .subscribe(async (res: HttpResponse<StudentDTO[]>) => {
                let temp: StudentDTO[] = [];
                this.actualStudList = res.body ? res.body : temp;
            });
    }

    getTagData() {
        this.search = {};
        this.search['status.equals'] = 'A';
        this.search.sort = 'name,asc';
        this.search.size = 500;
        this.search['schoolId.equals'] = this.userData.schoolId;
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryTag(this.search)
            .subscribe((res: HttpResponse<TagDTO[]>) => {
                let temp: TagDTO[] = [];
                this.tagList = res.body ? res.body : temp;
            });
    }

    getRoomData() {
        this.search = {};
        this.search['sort'] = 'name,asc'
        this.search['status.equals'] = 'A';
        this.search.size = 500;
        this.search['id.notEquals'] = this.roomObj.id;
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['id.in'] = !Common.isAdminUserLogin(this.storage) ? this.roomIds : undefined;
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryRooms(this.search)
            .subscribe((res: HttpResponse<RoomDTO[]>) => {
                let temp: RoomDTO[] = [];
                this.roomList = res.body ? res.body : temp;
            });
    }

    getMasterlookupData() {
        this.lookupService
            .queryMasterLookups({
                size: 10,
                'type.equals': 'Profile Status',
                'value.notEquals': 'I',
                sort: 'id,asc',
            })
            .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                let temp: MasterLookupDTO[] = [];
                this.statusList = res.body ? res.body : temp;
            });
    }

    createImgFromBuffer(blob: Blob) {
        const url = URL.createObjectURL(blob);
        return url;
    }
    onClear() {
        this.studentSearchInput = [];
        this.selectedRoomId = undefined;
        this.selectedTagId = [];
        this.selectedStatus = [];
        this.selectedStudents = [];
        this.actualStudList = [];
        this.selectedStudentIds = [];
        this.selectedStudentList = [];
        this.selectAllStudents = false;
        this.fromDate = Common.momentTimeZoneDate(new Date);
        this.toDate = Common.momentTimeZoneDate(new Date);
        this.todayDate = Common.momentTimeZoneDate(new Date);
        this.filter();
        this.filterRoom();
        this.filterTag();
        this.filterStatus();
        this.queryData();
    }

    filter() {
        let filtered: StudentDTO[] = [];

        if (this.studentSearchInput.length !== 0) {
            for (let i = 0; i < this.studentList.length; i++) {
                let user = this.studentList[i];
                if (
                    user?.fullName &&
                    (user.fullName.toLowerCase().indexOf(this.studentSearchInput.toLowerCase()) === 0 ||
                        user.fullName.toLowerCase().includes(this.studentSearchInput.toLowerCase()))
                ) {
                    filtered.push(user);
                }
            }
        } else {
            filtered = [...this.actualStudList];
        }

        this.studentList = [...filtered];
        this.checkboxChanged();
    }

    filterRoom() {
        let filtered: StudentDTO[] = [];
        this.studentList = [...this.actualStudList];
        if (this.selectedRoomId != undefined) {
            for (let i = 0; i < this.studentList.length; i++) {
                let user = this.studentList[i];
                if (user?.roomId && (user.roomId == this.selectedRoomId )) {
                    filtered.push(user);
                }
            }
        } else {
            filtered = [...this.actualStudList];
        }
        
    
        this.studentList = [...filtered];
        
        this.checkboxChanged();
    }
    filterTag() {
        let filtered: StudentDTO[] = [];
        if (this.selectedTagId.length === 0) {
            filtered = [...this.actualStudList];
        } else {
            // Create a Set for more efficient lookup
            const selectedTagSet = new Set(this.selectedTagId);

            filtered = this.actualStudList.filter(user =>
                user?.tags?.length &&
                user.tags.some(tag =>
                    // Check if current tag id matches any selected tag
                    selectedTagSet.has(tag.id)
                )
            );
        }

        this.studentList = [...filtered];
        this.checkboxChanged();
    }

    filterStatus() {
        let filtered: StudentDTO[] = [];
        if (this.selectedStatus.length === 0) {
            filtered = [...this.actualStudList];
        } else {
            const selectedStatusSet = new Set(this.selectedStatus);

            filtered = this.actualStudList.filter(user =>
                user?.profileStatus && selectedStatusSet.has(user.profileStatus)
            );
        }

        this.studentList = [...filtered];
        this.checkboxChanged();

    }

    onRemoveStud(event: Event, stud: any) {
        this.confirmationService.confirm({
            key: 'confirm2',
            target: event.target as EventTarget,
            message: `Do you want to Remove ${stud.fullName}?`,
            acceptButtonStyleClass: 'p-button-primary p-button-raised',
            rejectButtonStyleClass: 'p-button-secondary p-button-outlined',
            defaultFocus: 'none',
            accept: () => this.deleteStudents(stud),
            reject: () => { },
        });
    }

    deleteStudents(stud: any) {
        if (!stud || !stud.id) {
            return;
        }

        // Use filter instead of findIndex/splice to ensure we only remove the exact match
        this.selectedStudents = this.selectedStudents.filter(
            student => student.id !== stud.id
        );

        this.selectedStudentIds = this.selectedStudentIds.filter(
            id => id !== stud.id
        );

        this.selectedStudentList = [...this.selectedStudents];

        this.selectAllStudents = false;

        const mainListIndex = this.studentList.findIndex(
            (student) => student.id === stud.id
        );
        if (mainListIndex !== -1) {
            this.studentList[mainListIndex].selected = false;
        }

        this.submitForm = false;

        this.messageService.add({
            key: 'message',
            severity: 'success',
            life: 3000,
            summary: 'Success',
            detail: `Student Removed Successfully.`,
        });
    }

    toggleSelection(student: any) {
        const index = this.selectedStudents.findIndex(
            (selected) => selected.id === student.id
        );
        if (index !== -1) {
            this.selectedStudents.splice(index, 1);
        } else {
            this.selectedStudents.push(student);
        }
        this.selectedStudentIds = this.selectedStudents.map(
            (selected) => selected.id
        );

        this.selectedStudentList = [...this.selectedStudents];

    }

    isSelected(student: StudentDTO): boolean {
        return this.selectedStudents.includes(student);
    }

    toggleAllSelection() {
        this.studentList.forEach(
            (student) => (student.selected = this.selectAllStudents)
        );

        if (this.selectAllStudents) {
            this.selectedStudents = [...this.studentList];
        } else {
            this.selectedStudents = [];
        }
        this.selectedStudentIds = this.selectedStudents.map(
            (selected) => selected.id
        );

        this.selectedStudentList = [...this.selectedStudents];

    }

    checkboxChanged() {
        if (this.studentList && this.studentList?.length !== 0) {
            if (this.isAllSelected()) this.selectAllStudents = true;
            else this.selectAllStudents = false;
        } else {
            this.selectAllStudents = false;
        }
    }

    isAllSelected(): boolean {
        return this.studentList.every((student) => student.selected);
    }


    onClickDate(clickedDate: string) {
        if (clickedDate === 'fromDate') {
            // Ensure fromDate is not in the past
            const today = Common.momentTimeZoneDate(new Date());
            if (this.fromDate < today) {
                this.fromDate = today;
            }
            this.toDate = this.fromDate;
        }
        this.dateClickedFirstTime = true;
        this.search = {};
        this.queryData();
    }


    
    getInitials(roomName?: string): string {
        if (!roomName?.trim()) return ''; 
        const words = roomName.trim().split(/[-\s]+/);
        const firstLetter = words[0]?.[0]?.toUpperCase() || '';
        const secondLetter = words[1]?.[0]?.toUpperCase() || '';
        return `${firstLetter}${secondLetter}`.trim();
      }
      
    
      getBackgroundColor(roomId: any) {
        if (!roomId) return this.backgroundColors[0];
        const index = (roomId - 1) % this.backgroundColors.length;
        return this.backgroundColors[index];
      }
}
